<div>
	<div class="o-grid o-grid--wrap">
		<div class="o-grid__cell--w-100 o-grid__cell" *ngIf="!vm.loading">
			<div class="c-card u-osb-md">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell">
							<div *ngIf="vm.mispAuthRequired">
								<label for="mispPhone" class="c-form__label u-osb-xs">{{'PreVisit.Record_Ticket_For_Person.Misp_Authentication_Info' | translate}}</label>
								<br />
								<label class="c-form__label u-osb-xs" *ngIf="!vm.mispControlCode">{{'PreVisit.Record_Ticket_For_Person.Misp_Auth_Type' | translate}}</label>
								<fieldset *ngIf="!vm.mispControlCode">
									<label class="c-radio  u-ost-md">
										<input type="radio" name="authType" [value]="'SMART_ID'" [(ngModel)]="vm.authType">
										<span id="authTypeSmartId">{{'PreVisit.Record_Ticket_For_Person.Misp_Smart_Id' | translate}}</span>
									</label> 
									<label class="c-radio  u-ost-md">
										<input type="radio" name="authType" [value]="'MOBILE_ID'" [(ngModel)]="vm.authType">
										<span id="authTypeMobileId">{{'PreVisit.Record_Ticket_For_Person.Misp_Mobile_Id' | translate}}</span>
									</label>
								</fieldset>
								<br /> 
								<label for="mispPhone" class="c-form__label u-osb-xs" *ngIf="!vm.mispControlCode && vm.authType === 'MOBILE_ID'">
									{{'PreVisit.Record_Ticket_For_Person.Misp_Authentication_Mobile_Number_Input' | translate}}
								</label>
								<input type="text" id="mispPhone"
									name="mispPhone" class="c-form__input"
									*ngIf="!vm.mispControlCode && vm.authType === 'MOBILE_ID'"
									[(ngModel)]="vm.mispPhone"
									(keyup)="$event.keyCode === 13 && vm.startMispAuth()"
									autocomplete="off" />
								<p id="mispAuthFailedErrorLabel" class="c-text c-text--s3 u-osb-xs" *ngIf="vm.mispAuthFailed">
									{{'PreVisit.Record_Ticket_For_Person.Mobile_Id_Authentication_Failed' | translate}}
								</p>
								<button id="mispAuthStart" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="!vm.mispControlCode" (click)="vm.startMispAuth()">
									{{'PreVisit.Record_Ticket_For_Person.Misp_Authentication_Start_Button' | translate}}
								</button>
								&nbsp;
								<button id="myTicketsButton" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="!vm.mispControlCode" (click)="vm.openMyTickets()">
									{{'PreVisit.Record_Ticket_For_Person.My_Tickets' | translate}}
								</button>

								<label for="mispPhone" class="c-form__label u-osb-xs" *ngIf="vm.mispControlCode">
									{{'PreVisit.Record_Ticket_For_Person.Misp_Authentication_Control_Code' | translate}} {{vm.mispControlCode}}
								</label>
							</div>

							<div *ngIf="!vm.mispAuthRequired && vm.isValidatePatientStep1">
								<label for="patientUserCheck" class="c-form__label u-osb-xs">
									{{'PreVisit.Record_Ticket_For_Person.Patients_Identifier' | translate}}
								</label> 
								<input type="text" id="patientUserCheck"
									name="patientUserCheck" class="c-form__input"
									[(ngModel)]="vm.userEstonianIdentificationCode"
									(keyup)="$event.keyCode === 13 && vm.validatePatientIdentifier()"
									autocomplete="off" />
								<p id="showIdentifierDoesNotValidateErrorLabel" class="c-text c-text--s3 u-osb-xs" 
									*ngIf="vm.showIdentifierDoesNotValidate">
									{{'PreVisit.Record_Ticket_For_Person.Identifier_Not_Valid' | translate}}
								</p>
								<p id="insuranceDataNotFoundLabel" class="c-text c-text--s3 u-osb-xs"
									*ngIf="vm.isInsuranceDataNotFound">
									{{'PreVisit.Record_Ticket_For_Person.Insurance_Data_Not_Found' | translate}}
								</p>
								<p id="isUserConsentsNotGivenErrorLabel" class="c-text c-text--s3 u-osb-xs"
									*ngIf="vm.isUserConsentsNotGiven">
									{{'PreVisit.Record_Ticket_For_Person.Consents_Not_Given' | translate}}
								</p>
								<button id="validatePatientIdentifierButton" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="!vm.isValidatePatientStep2 && !vm.showCreateUserButton"
									(click)="vm.validatePatientIdentifier()">
									{{'PreVisit.Record_Ticket_For_Person.Search_User' | translate}}
								</button>
								&nbsp;
								<button id="myTicketsButton2" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="!vm.isValidatePatientStep2 && !vm.showCreateUserButton"
									(click)="vm.openMyTickets()">
									{{'PreVisit.Record_Ticket_For_Person.My_Tickets' | translate}}
								</button>

								<div *ngIf="vm.isValidatePatientStep2"
									[ngClass]="{ 'c-form__group--error': vm.validatePatientStep2Invalid }">
									<label for="requesterUserCheck" class="c-form__label u-osb-xs u-ost-md">
										{{'PreVisit.Record_Ticket_For_Person.Contacting_Person' | translate}}
									</label>
									<label class="c-radio">
										<input type="radio" name="isPatient" [(ngModel)]="vm.callerRole" value="isPatient"> 
										<span id="isPatientLabel">
											{{'PreVisit.Record_Ticket_For_Person.Is_Patient' | translate}}
										</span>
									</label>
									<label class="c-radio"> 
										<input type="radio" name="isRepresenter" [(ngModel)]="vm.callerRole" value="isRepresenter">
										<span id="isRepresenterLabel">
											{{'PreVisit.Record_Ticket_For_Person.Is_Representative' | translate}}
										</span>
									</label>
								</div>

								<button id="validatePatientIdentifierButton2" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="vm.isValidatePatientStep2"
									(click)="vm.validatePatientIdentifier()">
									{{'PreVisit.Common.Forward' | translate}}
								</button>
							</div>

							<div *ngIf="!vm.mispAuthRequired && vm.isValidateRecorderStep1">
								<label for="requesterUserCheck" class="c-form__label u-osb-xs">
									{{'PreVisit.Record_Ticket_For_Person.Representative_Identifier' | translate}} 
								</label>
								<input type="text" id="requesterUserCheck"
									name="requesterUserCheck" class="c-form__input"
									[(ngModel)]="vm.userEstonianIdentificationCode"
									(keyup)="$event.keyCode === 13 && vm.validateRequesterIdentifier()"
									autocomplete="off" />
								<p class="c-text c-text--s3 u-osb-xs" *ngIf="vm.showIdentifierDoesNotValidate">
									{{'PreVisit.Record_Ticket_For_Person.Identifier_Not_Valid' | translate}}
								</p>
								<p class="c-text c-text--s3 u-osb-xs" *ngIf="vm.isInsuranceDataNotFound">
									{{'PreVisit.Record_Ticket_For_Person.Insurance_Data_Not_Found' | translate}}
								</p>
								<p class="c-text c-text--s3 u-osb-xs" *ngIf="vm.requesterGpNotFound">
									{{'PreVisit.Record_Ticket_For_Person.Requester_Gp_Not_Found' | translate}}
								</p>
								<p class="c-text c-text--s3 u-osb-xs" *ngIf="vm.isUserConsentsNotGiven">
									{{'PreVisit.Record_Ticket_For_Person.Consents_Not_Given' | translate}}
								</p>
								<button id="validateRequesterIdentifierButton" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="!vm.isValidateRecorderStep2 && !vm.showCreateUserButton"
									(click)="vm.validateRequesterIdentifier()">
									{{'PreVisit.Record_Ticket_For_Person.Search_User' | translate}}
								</button>

								<div *ngIf="vm.isValidateRecorderStep2" [ngClass]="{ 'c-form__group--error': vm.noConnectionDefined }">
									<label for="requesterUserCheck" class="c-form__label u-osb-xs u-ost-md">
										{{'PreVisit.Record_Ticket_For_Person.Connection_With_Patient' | translate}} 
									</label>
									<label class="c-radio">
										<input type="radio" name="nextOfKin"
											[(ngModel)]="vm.requesterRelationshipToPatient" value="NOK">
										<span id="nextOfKinLabel">
											{{'PreVisit.Record_Ticket_For_Person.Next_Of_Kin' | translate}}
										</span>
									</label>
									<label class="c-radio">
										<input type="radio" name="dependant"
											[(ngModel)]="vm.requesterRelationshipToPatient" value="DEPEN">
										<span id="dependantLabel">
											{{'PreVisit.Record_Ticket_For_Person.Dependant' | translate}}
										</span>
									</label>
									<label class="c-radio">
										<input type="radio" name="delegatee" 
											[(ngModel)]="vm.requesterRelationshipToPatient" value="DELEGATEE">
										<span id="delegateeLabel">
											{{'PreVisit.Record_Ticket_For_Person.Care_Taker' | translate}}
										</span>
									</label>
									<label class="c-radio">
										<input type="radio" name="contact" 
											[(ngModel)]="vm.requesterRelationshipToPatient" value="CONT">
										<span id="contactLabel">
											{{'PreVisit.Record_Ticket_For_Person.Other_Contact' | translate}}
										</span>
									</label>
								</div>
								<button id="validateRequesterIdentifierButton2" type="button"
									class="c-button c-button--s1 u-ost-md"
									*ngIf="vm.isValidateRecorderStep2"
									(click)="vm.validateRequesterIdentifier()">
									{{'PreVisit.Common.Forward' | translate}}</button>
							</div>

							<div *ngIf="!vm.mispAuthRequired && vm.showCreateUserButton">
								<button id="showCreateUserModalButton" type="button"
									class="c-button c-button--s2 u-ost-md"
									(click)="vm.showCreateUserModel()">
									{{'PreVisit.Record_Ticket_For_Person.Create_User' | translate}}
								</button>
							</div>
							<div *ngIf="!vm.mispAuthRequired && vm.isUserConsentsNotGiven">
								<button id="showGivenConsentsModalButton" type="button"
									class="c-button c-button--s2 u-ost-md"
									(click)="vm.showGiveConsentsModel()">
									{{'PreVisit.Record_Ticket_For_Person.Give_Consents' | translate}}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<loader-overlay *ngIf="vm.loading"></loader-overlay>
	</div>
</div>
